import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const deviceListAgentAdminRoutes = {
  path: 'device-list-agent-admin',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.deviceAgent.list'),
  },
  children: [
    {
      path: '',
      name: 'deviceListAgentAdmin',
      component: () =>
        lazyLoadView(import('@views/DeviceListAgentAdmin/list.vue')),
      meta: {
        authRequired: [ROLE.AGENT_ADMIN, ROLE.AGENT_SUB, ROLE.AGENT_AUDIT],
      },
    },
    {
      path: ':id',
      name: 'deviceListAgentAdminDetail',
      component: () =>
        lazyLoadView(import('@views/DeviceListAgentAdmin/details.vue')),
      meta: {
        authRequired: [ROLE.AGENT_ADMIN, ROLE.AGENT_SUB, ROLE.AGENT_AUDIT],
        label: i18n.t('router.deviceAgent.details'),
      },
    },
  ],
}

export default deviceListAgentAdminRoutes
